import { GlobalRoutes } from './global-routes';

export const JOBS_FOOTER_LINK = {
	label: 'Jobs',
	href: GlobalRoutes.JobsHome,
	newTab: true,
};

export const PRIVACY_POLICY_US_LINK = {
	label: 'Privacy Policy',
	href: GlobalRoutes.PrivacyUs,
	newTab: true,
};

export const ABOUT_US_FOOTER_LINK = {
	label: 'About Us',
	href: GlobalRoutes.AboutHome,
	newTab: true,
};
